import React, { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { useI18n } from '../i18n';

export default function MagicLinkHandler() {
  const navigate = useNavigate();
  const { login } = useContext(AuthContext); // Extraemos la función oficial del contexto
  const { language } = useI18n();

  useEffect(() => {
    const hash = window.location.hash;

    if (hash && hash.startsWith('#token=')) {
      const token = hash.replace('#token=', '');

      // 1. Safe Token Extraction: Validate JWT structure before processing
      const jwtRegex = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+$/;
      if (!jwtRegex.test(token)) {
        console.error('Invalid token format in magic link');
        navigate('/login');
        return;
      }

      // 2. Limpiamos la URL visualmente por seguridad y estética
      window.history.replaceState(null, null, ' ');

      // 3. Invocamos el método oficial de la app.
      // Esto garantiza que se seteen headers, estado en memoria y el localStorage correcto.
      login(token);

      // 4. Redirigimos usando el router de React al Dashboard/Main
      navigate('/');
    } else {
      navigate('/login');
    }
  }, [navigate, login]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: 'var(--bg-color, #000)' }}>
      <div className="mutantbox-loading" style={{ color: '#4caf50' }}>
        {language === 'en' ? 'Synchronizing with the Portal...' : 'Sincronizando con el Portal...'}
      </div>
    </div>
  );
}
